/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import {EEmbededElementTypes, RenderDocument} from "js_renderer";
import {vec3} from "gl-matrix";
import GeometryEntity from "./geometry_entity";

export default
class PointEntity extends GeometryEntity {
    constructor(aRenderDocument: RenderDocument) {
        super(aRenderDocument);

        this.extendProperties({
            position: vec3.create(),
            title: '',
            description: '',
            url: '',
            resourceUrl: '',
            images: []
        });
    }

    public extendProperties(aProperties: any) {
        // extend the properties
        super.extendProperties(aProperties);

        if (this._properties.position !== undefined && aProperties.position !== undefined) {
            this._properties.position = vec3.clone(aProperties.position);
        }
    }

    /***
     * Returns position with zeropoint included.
     *
     * @returns {vec3}
     */
    public getPosition(): vec3 {
        let sourceGeometryObjects = this._renderDocumentProperties.renderElement.getGeometryObjects();
        let positionDesc = sourceGeometryObjects[0].getGeometry().positionsDesc;
        return vec3.fromValues(positionDesc.data[0], positionDesc.data[1], positionDesc.data[2]);
    }
}
